module.exports = __webpack_public_path__ + "static/media/building-gif.39313eab.gif";